document.addEventListener('DOMContentLoaded', function () {
  var sticky = document.querySelector('[data-mb-sticky-cart]');
  var stickyButton = document.querySelector('[data-mb-sticky-button]');
  var mainButton = document.querySelector('.template-product .pr_btn.addtocart_js');
  if (!sticky || !stickyButton || !mainButton) return;

  var sync = function () {
    stickyButton.disabled = !!mainButton.disabled;
    stickyButton.textContent = mainButton.disabled ? 'Uitverkocht' : 'In winkelwagen';
    var visiblePrice = document.querySelector('.template-product .pr_price_single [id^="ProductPrice-"]');
    var stickyPrice = document.querySelector('[data-mb-sticky-price]');
    if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
  };

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    sticky.classList.toggle('is-visible', !entry.isIntersecting);
    sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
  }, { threshold: 0.15 });
  observer.observe(mainButton);

  stickyButton.addEventListener('click', function () {
    sync();
    if (!mainButton.disabled) mainButton.click();
  });

  new MutationObserver(sync).observe(mainButton, { attributes:true, childList:true, subtree:true });
  document.addEventListener('change', function (event) {
    if (event.target.closest('.productForm')) setTimeout(sync, 60);
  });
  sync();
});
